<svg
  width="21"
  height="20"
  viewBox="0 0 21 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M13.821 5.28662L10.2852 8.82162L6.75017 5.28662L5.57184 6.46495L9.10684 9.99995L5.57184 13.535L6.75017 14.7133L10.2852 11.1783L13.821 14.7133L14.9993 13.535L11.4643 9.99995L14.9993 6.46495L13.821 5.28662Z"
    fill="#787E87"
  />
</svg>
